module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "admin-portal-analytics-container"
  }, [_c('div', {
    staticClass: "row col-xs no-margin no-padding"
  }, [_c('adminViewAnalyticsFiltersBar', {
    on: {
      "date_filter": _vm.searchAnalytics
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row mt4"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('adminViewAnalyticsGeneralInfo', {
    attrs: {
      "numberOfTeachersThatCreatedAtLeastOneRt": _vm.number_of_teachers_that_created_at_least_one_rt,
      "numberActiveStudents": _vm.number_active_students,
      "numberOfTeachersThatRanAtLeastOneRt": _vm.number_of_teachers_that_ran_at_least_one_rt,
      "numberActivitiesCreated": _vm.number_of_activities_created,
      "numberActivitiesRun": _vm.number_of_activities_run,
      "numberOfLiveDiscussionsCreated": _vm.number_of_lds_created,
      "numberOfLiveDiscussionsRun": _vm.number_of_lds_run,
      "numberOfRtsCreatedFromUniverse": _vm.number_of_rts_created_from_universe
    },
    on: {
      "showRoundtablesInfo": _vm.showRoundtablesModal
    }
  })], 1)]), _vm._v(" "), (_vm.show_roundtables_list) ? _c('pl-dialog', {
    attrs: {
      "title": _vm.header_modal,
      "size": 'md'
    },
    on: {
      "close": _vm.closeModal
    }
  }, [_c('body', {
    staticClass: "px-7 pt-7 pb-4 mb-3 flex-grow overflow-y-auto"
  }, [_c('table', {
    staticClass: "mt-3 w-100"
  }, [_c('thead', {
    staticClass: "flex font-bold"
  }, [_c('td', {
    staticClass: "col-xs-4"
  }, [_vm._v("Title")]), _vm._v(" "), _c('td', {
    staticClass: "col-xs-2"
  }, [_vm._v("Students Invited")]), _vm._v(" "), _c('td', {
    staticClass: "col-xs-3"
  }, [_vm._v("Teacher")]), _vm._v(" "), _c('td', {
    staticClass: "col-xs-3"
  }, [_vm._v("Course / Section")])]), _vm._v(" "), _c('div', {
    staticClass: "mx-3",
    attrs: {
      "id": "admin-view-roundtables-table"
    },
    on: {
      "scroll": function($event) {
        return _vm.handleScroll(_vm.page_number)
      }
    }
  }, _vm._l((_vm.roundtables_to_show), function(rt, index) {
    return _c('tr', {
      key: index,
      staticClass: "row middle-xs row-style"
    }, [_c('td', {
      staticClass: "col-xs-4 truncate-text",
      class: rt.course_school_id ? 'linkable text-primary' : '',
      on: {
        "click": function($event) {
          return _vm.goToRoundtable(_vm.header_modal, rt)
        }
      }
    }, [_vm._v("\n              " + _vm._s(rt.title) + "\n            ")]), _vm._v(" "), _c('td', {
      staticClass: "col-xs-2 truncate-text p4"
    }, [_vm._v("\n              " + _vm._s(rt.invited_users) + "\n            ")]), _vm._v(" "), _c('td', {
      staticClass: "col-xs-3 truncate-text"
    }, [_vm._v("\n              " + _vm._s(rt.teacher) + "\n            ")]), _vm._v(" "), _c('td', {
      staticClass: "col-xs-3 truncate-text",
      class: rt.course_school_id ? 'linkable text-primary' : '',
      on: {
        "click": function($event) {
          return _vm.goToCourse(rt)
        }
      }
    }, [_vm._v("\n              " + _vm._s(rt.course_title) + "\n            ")])])
  }), 0)])])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-145ca4fe!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/admin/adminPortal/adminPortalParlay/adminPortalParlayAnalytics/adminViewAnalytics.vue
// module id = 2207
// module chunks = 61